module.exports = __webpack_public_path__ + "static/media/2010_Karneval_(2).8d3db620.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/gallery/TK_karneval/2010_Karneval_(2).jpg
// module id = 453
// module chunks = 0